<template>
	<div class="strasbourg-landing">
		<!-- Animated background -->
		<div class="bg-gradient"></div>
		<div class="bg-orb bg-orb-1"></div>
		<div class="bg-orb bg-orb-2"></div>
		<div class="bg-orb bg-orb-3"></div>
		<div class="bg-grid"></div>

		<!-- Plane silhouette -->
		<img class="bg-plane" src="@/assets/icon-plane.png" alt="" aria-hidden="true" />

		<!-- Top bar -->
		<header class="landing-header">
			<div class="brand-mark">
				<img src="@/assets/logo.png" alt="Pika Aero" class="brand-logo-pika" />
			</div>
			<router-link :to="{ name: 'login' }" class="header-login">
				Se connecter
				<i class="ri-arrow-right-line"></i>
			</router-link>
		</header>

		<!-- Hero -->
		<main class="landing-main">
			<div class="hero">
				<div class="hero-logos">
					<img src="@/assets/logo-strasbourg.png" alt="Aéroport de Strasbourg" class="hero-logo hero-logo-strasbourg" />
				</div>

				<h1 class="hero-title">
					Bienvenue sur la plateforme<br/>
					<span class="hero-title-accent">Aéroport de Strasbourg</span>
				</h1>

				<p class="hero-subtitle">
					Formations agréées, conformité aéroportuaire et suivi des habilitations —
					une plateforme unique pour les acteurs de l'Aéroport de Strasbourg.
				</p>

				<div class="hero-ctas">
					<router-link :to="{ name: 'register' }" class="btn-primary-hero">
						<span>Créer mon compte</span>
						<i class="ri-arrow-right-line"></i>
					</router-link>
					<router-link :to="{ name: 'login' }" class="btn-secondary-hero">
						J'ai déjà un compte
					</router-link>
				</div>
			</div>

			<!-- Trainings carousel -->
			<section class="trainings">
				<div class="trainings-heading">
					<span class="trainings-eyebrow">Découvrez notre catalogue</span>
				</div>

				<div class="carousel" aria-label="Catalogue de formations">
					<div class="carousel-track">
						<div class="training-card" v-for="(t, i) in carouselTrainings" :key="i">
							<div class="training-img-wrap">
								<img :src="t.image" :alt="t.title" loading="lazy" />
							</div>
							<div class="training-body">
								<span class="training-tag">{{ t.category }}</span>
								<h4>{{ t.title }}</h4>
								<span class="training-duration">
									<i class="ri-time-line"></i> {{ t.duration }}
								</span>
							</div>
						</div>
					</div>
				</div>
			</section>
		</main>

		<footer class="landing-footer">
			<span>© {{ year }} Pika Aero</span>
			<span class="footer-sep">·</span>
			<a href="https://pika-aero.com" target="_blank" rel="noopener">pika-aero.com</a>
		</footer>
	</div>
</template>

<script>
const TRAININGS = [
	{ title: "Sécurité Piéton", category: "Sécurité aérienne", duration: "1h30", image: "https://pika-aero.com/trainings/SecuritePieton.jpeg" },
	{ title: "Sécurité Piéton MAN/TRA - ADP", category: "Sécurité aérienne", duration: "2h", image: "https://pika-aero.com/trainings/SecuritePieton_ADP.jpeg" },
	{ title: "Co-Activité en Piste", category: "Sécurité aérienne", duration: "3h30", image: "https://pika-aero.com/trainings/CO-Activite.jpeg" },
	{ title: "Facteurs Humains", category: "Sécurité aérienne", duration: "1h30", image: "https://pika-aero.com/trainings/FH.jpeg" },
	{ title: "SGS", category: "Sécurité aérienne", duration: "5h", image: "https://pika-aero.com/trainings/SGS.jpeg" },
	{ title: "PHMR", category: "Sécurité aérienne", duration: "2h30", image: "https://pika-aero.com/trainings/PHMR.jpeg" },
	{ title: "11.2.6.2", category: "Sûreté aérienne", duration: "3h", image: "https://pika-aero.com/trainings/11.2.6.2.jpeg" },
	{ title: "11.2.8", category: "Sûreté aérienne", duration: "30min", image: "https://pika-aero.com/trainings/11.2.8.jpeg" },
	{ title: "11.2.3.6", category: "Sûreté aérienne", duration: "3h30", image: "https://pika-aero.com/trainings/11.2.3.6.jpeg" },
	{ title: "11.2.3.7", category: "Sûreté aérienne", duration: "3h30", image: "https://pika-aero.com/trainings/11.2.3.7.jpeg" },
	{ title: "11.2.3.8", category: "Sûreté aérienne", duration: "3h30", image: "https://pika-aero.com/trainings/11.2.3.8.jpeg" },
	{ title: "11.2.3.9 (AHa)", category: "Sûreté aérienne", duration: "3h30", image: "https://pika-aero.com/trainings/11.2.3.9.jpeg" },
	{ title: "11.2.3.10", category: "Sûreté aérienne", duration: "3h30", image: "https://pika-aero.com/trainings/11.2.3.10.jpeg" },
];

export default {
	name: "LandingStrasbourg",
	computed: {
		year() {
			return new Date().getFullYear();
		},
		carouselTrainings() {
			return [...TRAININGS, ...TRAININGS];
		},
	},
};
</script>

<style scoped>
.strasbourg-landing {
	position: fixed;
	inset: 0;
	overflow-y: auto;
	overflow-x: hidden;
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
	color: #0f172a;
	background: #f8fafc;
}

/* Animated background */
.bg-gradient {
	position: fixed;
	inset: 0;
	background: linear-gradient(135deg, #eef2ff 0%, #faf5ff 40%, #fef3f2 100%);
	z-index: 0;
}

.bg-orb {
	position: fixed;
	border-radius: 50%;
	filter: blur(80px);
	opacity: 0.5;
	z-index: 1;
	pointer-events: none;
}

.bg-orb-1 {
	width: 500px;
	height: 500px;
	background: radial-gradient(circle, #818cf8 0%, transparent 70%);
	top: -150px;
	left: -100px;
	animation: float-1 18s ease-in-out infinite;
}

.bg-orb-2 {
	width: 600px;
	height: 600px;
	background: radial-gradient(circle, #c084fc 0%, transparent 70%);
	bottom: -200px;
	right: -150px;
	animation: float-2 22s ease-in-out infinite;
}

.bg-orb-3 {
	width: 400px;
	height: 400px;
	background: radial-gradient(circle, #38bdf8 0%, transparent 70%);
	top: 40%;
	left: 50%;
	transform: translateX(-50%);
	opacity: 0.3;
	animation: float-3 15s ease-in-out infinite;
}

@keyframes float-1 {
	0%, 100% { transform: translate(0, 0) scale(1); }
	50% { transform: translate(60px, 80px) scale(1.1); }
}

@keyframes float-2 {
	0%, 100% { transform: translate(0, 0) scale(1); }
	50% { transform: translate(-80px, -60px) scale(1.15); }
}

@keyframes float-3 {
	0%, 100% { transform: translate(-50%, 0) scale(1); }
	50% { transform: translate(-50%, -40px) scale(1.08); }
}

.bg-grid {
	position: fixed;
	inset: 0;
	background-image:
		linear-gradient(rgba(15, 23, 42, 0.04) 1px, transparent 1px),
		linear-gradient(90deg, rgba(15, 23, 42, 0.04) 1px, transparent 1px);
	background-size: 60px 60px;
	mask-image: radial-gradient(ellipse at center, black 30%, transparent 70%);
	-webkit-mask-image: radial-gradient(ellipse at center, black 30%, transparent 70%);
	z-index: 2;
	pointer-events: none;
}

.bg-plane {
	position: fixed;
	width: 168px;
	height: auto;
	top: 15%;
	right: 8%;
	z-index: 2;
	pointer-events: none;
	user-select: none;
	animation: plane-drift 12s ease-in-out infinite;
}

@keyframes plane-drift {
	0%, 100% { transform: translate(0, 0); }
	50% { transform: translate(20px, -15px); }
}

/* Header */
.landing-header {
	position: relative;
	z-index: 10;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 28px 56px;
}

.brand-mark {
	display: flex;
	align-items: center;
}

.brand-logo-pika {
	height: 32px;
	width: auto;
}

.header-login {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	padding: 10px 20px;
	border-radius: 999px;
	background: rgba(255, 255, 255, 0.7);
	backdrop-filter: blur(12px);
	-webkit-backdrop-filter: blur(12px);
	border: 1px solid rgba(15, 23, 42, 0.08);
	color: #0f172a;
	text-decoration: none;
	font-size: 14px;
	font-weight: 500;
	transition: all 0.2s ease;
}

.header-login:hover {
	background: rgba(255, 255, 255, 0.95);
	transform: translateY(-1px);
	box-shadow: 0 4px 20px rgba(99, 102, 241, 0.15);
}

.header-login i {
	font-size: 16px;
	transition: transform 0.2s ease;
}

.header-login:hover i {
	transform: translateX(2px);
}

/* Hero */
.landing-main {
	position: relative;
	z-index: 10;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 40px 56px 80px;
}

.hero {
	max-width: 1100px;
	width: 100%;
	text-align: center;
	animation: fade-up 0.8s ease-out;
}

@keyframes fade-up {
	from {
		opacity: 0;
		transform: translateY(20px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

.hero-logos {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 32px;
	margin-bottom: 48px;
	flex-wrap: wrap;
}

.hero-logo {
	height: 64px;
	width: auto;
	max-width: 240px;
	object-fit: contain;
	filter: drop-shadow(0 4px 16px rgba(15, 23, 42, 0.08));
}

.hero-cross {
	font-size: 36px;
	font-weight: 200;
	color: #94a3b8;
	line-height: 1;
}

.hero-title {
	font-size: 56px;
	line-height: 1.1;
	font-weight: 800;
	letter-spacing: -0.03em;
	margin: 0 0 24px;
	color: #0f172a;
}

.hero-title-accent {
	background: linear-gradient(135deg, #6366f1 0%, #a855f7 50%, #ec4899 100%);
	-webkit-background-clip: text;
	background-clip: text;
	-webkit-text-fill-color: transparent;
	color: transparent;
}

.hero-subtitle {
	font-size: 19px;
	line-height: 1.6;
	color: #475569;
	max-width: 640px;
	margin: 0 auto 48px;
}

.hero-ctas {
	display: flex;
	gap: 16px;
	justify-content: center;
	margin-bottom: 0;
	flex-wrap: wrap;
}

.btn-primary-hero {
	display: inline-flex;
	align-items: center;
	gap: 10px;
	padding: 16px 32px;
	background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
	color: white;
	text-decoration: none;
	font-size: 16px;
	font-weight: 600;
	border-radius: 14px;
	box-shadow: 0 10px 30px rgba(99, 102, 241, 0.35), 0 2px 8px rgba(99, 102, 241, 0.2);
	transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-primary-hero:hover {
	transform: translateY(-2px);
	box-shadow: 0 16px 40px rgba(99, 102, 241, 0.45), 0 4px 12px rgba(99, 102, 241, 0.3);
	color: white;
}

.btn-primary-hero i {
	transition: transform 0.25s ease;
}

.btn-primary-hero:hover i {
	transform: translateX(4px);
}

.btn-secondary-hero {
	display: inline-flex;
	align-items: center;
	padding: 16px 32px;
	background: rgba(255, 255, 255, 0.8);
	backdrop-filter: blur(12px);
	-webkit-backdrop-filter: blur(12px);
	color: #334155;
	text-decoration: none;
	font-size: 16px;
	font-weight: 600;
	border-radius: 14px;
	border: 1px solid rgba(15, 23, 42, 0.1);
	transition: all 0.25s ease;
}

.btn-secondary-hero:hover {
	background: white;
	transform: translateY(-2px);
	color: #0f172a;
	box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

/* Trainings carousel */
.trainings {
	width: 100%;
	margin-top: 96px;
	animation: fade-up 1s ease-out 0.2s both;
}

.trainings-heading {
	text-align: center;
	margin: 0 auto 28px;
}

.trainings-eyebrow {
	display: inline-block;
	font-size: 12px;
	font-weight: 600;
	letter-spacing: 0.12em;
	text-transform: uppercase;
	color: #94a3b8;
}

.carousel {
	position: relative;
	width: 100vw;
	margin-left: calc(50% - 50vw);
	overflow: hidden;
	mask-image: linear-gradient(90deg, transparent 0, black 8%, black 92%, transparent 100%);
	-webkit-mask-image: linear-gradient(90deg, transparent 0, black 8%, black 92%, transparent 100%);
	padding: 8px 0;
}

.carousel-track {
	display: flex;
	gap: 24px;
	width: max-content;
	animation: carousel-scroll 50s linear infinite;
}

.carousel:hover .carousel-track {
	animation-play-state: paused;
}

@keyframes carousel-scroll {
	from { transform: translateX(0); }
	to { transform: translateX(-50%); }
}

.training-card {
	flex: 0 0 280px;
	background: rgba(255, 255, 255, 0.85);
	backdrop-filter: blur(20px);
	-webkit-backdrop-filter: blur(20px);
	border: 1px solid rgba(255, 255, 255, 0.9);
	border-radius: 20px;
	overflow: hidden;
	box-shadow: 0 4px 24px rgba(15, 23, 42, 0.06);
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.training-card:hover {
	transform: translateY(-6px);
	box-shadow: 0 20px 40px rgba(99, 102, 241, 0.15);
}

.training-img-wrap {
	position: relative;
	width: 100%;
	aspect-ratio: 16 / 10;
	overflow: hidden;
	background: linear-gradient(135deg, #ede9fe, #ddd6fe);
}

.training-img-wrap img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	display: block;
	transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.training-card:hover .training-img-wrap img {
	transform: scale(1.06);
}

.training-body {
	padding: 18px 20px 20px;
}

.training-tag {
	display: inline-block;
	font-size: 11px;
	font-weight: 700;
	letter-spacing: 0.06em;
	text-transform: uppercase;
	color: #6366f1;
	background: rgba(99, 102, 241, 0.1);
	padding: 4px 10px;
	border-radius: 999px;
	margin-bottom: 10px;
}

.training-body h4 {
	font-size: 18px;
	font-weight: 700;
	margin: 0 0 8px;
	color: #0f172a;
	letter-spacing: -0.01em;
}

.training-duration {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	font-size: 13px;
	color: #64748b;
	font-weight: 500;
}

.training-duration i {
	font-size: 15px;
}

/* Footer */
.landing-footer {
	position: relative;
	z-index: 10;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 10px;
	padding: 32px 56px;
	font-size: 13px;
	color: #94a3b8;
}

.footer-sep {
	opacity: 0.5;
}

.landing-footer a {
	color: #64748b;
	text-decoration: none;
	transition: color 0.2s ease;
}

.landing-footer a:hover {
	color: #6366f1;
}

/* Responsive */
@media (max-width: 768px) {
	.landing-header {
		padding: 20px 24px;
	}
	.landing-main {
		padding: 20px 24px 60px;
	}
	.hero-title {
		font-size: 36px;
	}
	.hero-subtitle {
		font-size: 16px;
	}
	.hero-logos {
		gap: 20px;
	}
	.hero-logo {
		height: 48px;
	}
	.hero-cross {
		font-size: 28px;
	}
	.hero-ctas {
		flex-direction: column;
		align-items: stretch;
	}
	.btn-primary-hero,
	.btn-secondary-hero {
		justify-content: center;
	}
	.trainings {
		margin-top: 64px;
	}
	.training-card {
		flex: 0 0 240px;
	}
	.bg-plane {
		width: 180px;
		height: 180px;
		top: 5%;
		right: -40px;
	}
}
</style>
